(() => {
  'use strict';

  const addHiddenInput = (form, name, value) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.dataset.productAddOnLineItem = '';
    form.append(input);
    return input;
  };

  const getQuantityInput = (form) => {
    const formQuantity = form.querySelector('input[name="quantity"]');
    const externalQuantity = document.querySelector(`[form="${form.id}"][name="quantity"]`);
    return externalQuantity || formQuantity;
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement) || form.dataset.type !== 'add-to-cart-form') return;

      const productSection = form.closest('.main-product__wrapper');
      const addOns = productSection?.querySelector('[data-product-add-ons]');
      const selectedAddOns = addOns?.querySelectorAll('[data-product-add-on]:checked');

      if (!selectedAddOns?.length) return;

      const variantInput = form.querySelector('input[name="id"]');
      if (!variantInput?.value) return;

      const quantityInput = getQuantityInput(form);
      const originalVariantName = variantInput.name;
      const originalQuantityName = quantityInput?.name;
      const temporaryInputs = [];

      variantInput.name = 'items[0][id]';

      if (quantityInput) {
        quantityInput.name = 'items[0][quantity]';
      } else {
        temporaryInputs.push(addHiddenInput(form, 'items[0][quantity]', '1'));
      }

      selectedAddOns.forEach((addOn, index) => {
        const itemIndex = index + 1;
        temporaryInputs.push(addHiddenInput(form, `items[${itemIndex}][id]`, addOn.dataset.variantId));
        temporaryInputs.push(addHiddenInput(form, `items[${itemIndex}][quantity]`, '1'));
      });

      window.setTimeout(() => {
        variantInput.name = originalVariantName;
        if (quantityInput && originalQuantityName) quantityInput.name = originalQuantityName;
        temporaryInputs.forEach((input) => input.remove());
      }, 0);
    },
    true
  );
})();
